/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import React, { useMemo, useRef } from "react";
import { IButtonProps, Button } from "./Button";

/**
 * Component props
 */
export interface IButtonOpenProps extends IButtonProps {
	onOpen: (files: FileList) => void;
	accept?: string;
}

/**
 * Open Button component
 *
 * @param props Component props
 */
export function ButtonOpen(props: IButtonOpenProps) {

	const fileInputRef = useRef(null);

	const handleClick = useMemo(() => () => {

		const inputEl = fileInputRef.current as HTMLInputElement;
		inputEl.click();
		inputEl.value = "";

		if (props.onClick) {
			props.onClick();
		}

	}, [ props.onClick ]);

	const handleChange = useMemo(() => () => {

		props.onOpen(fileInputRef.current.files);

	}, [ props.onOpen ]);

	return <Button
		{...props}
		onClick={handleClick}
		renderCustom={() =>
			<input
				className="button__fileInput"
				type="file"
				accept={props.accept}
				ref={fileInputRef}
				onInput={handleChange}
			/>
		}
	/>;

}
